// extracted by mini-css-extract-plugin
module.exports = {"confirmation":"styles_confirmation__17ibl","buttons":"styles_buttons__1GaOx"};